import { getSettingChat } from 'api/chat/setting/get-setting';
import { useSubscription } from 'hooks/use-subscription.hook';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LIST_SIDEBAR } from './components/list-sidebar';
import Appearance from './components/tab-content/appearance';
import Chat from './components/tab-content/chat';
import General from './components/tab-content/general';
import Message from './components/tab-content/message';
import Notification from './components/tab-content/notification';
import Profile from './components/tab-content/profile';
import { RequestDataSetting } from 'api/chat/setting/update-setting';
import { SettingChat } from 'pages/chat/consts';

function ModalSetting() {
  const { t } = useTranslation();
  const subscription = useSubscription();

  const [navActove, setNavActive] = useState<number>(0);
  const [DataSetting, setDataSetting] = useState<RequestDataSetting>();
  const contentRef = useRef([]);

  const handleClick = (idx) => {
    setNavActive(idx);

    for (let i = 0; i < contentRef.current.length; i++) {
      if (contentRef.current[i].getAttribute('class').includes('active')) {
        contentRef.current[i].classList.remove('active');
      }
    }

    contentRef.current[idx].classList.add('active');
  };

  useEffect(() => {
    contentRef.current[0].classList.add('active');

    const data = getSettingChat().subscribe({
      next: (res) => {
        setDataSetting(res.data);
      },
    });

    subscription.add(data);
  }, [subscription]);

  return (
    <div className='modal-content'>
      <div className='modal-header h-d_flex -justify-center'>
        <div className='modal-title h4'>{t('Setting')}</div>
      </div>
      <div className='modal-body setting-chat'>
        <div className='modal-tab'>
          {LIST_SIDEBAR.map((dataItem, idx) => (
            <div
              key={idx}
              className='tab-item'
              ref={(element) => {
                contentRef.current[idx] = element;
              }}
              onClick={() => handleClick(idx)}
            >
              <div className='item-tab-img'>
                <img src={dataItem.icon} alt='img' />
              </div>
              <span className='item-tab-text'>{dataItem.title}</span>
            </div>
          ))}
        </div>
        <div className='modal-text-content'>
          <div className='item-content'>
            {navActove === SettingChat.general && <General self={DataSetting} />}
            {navActove === SettingChat.profile && <Profile self={DataSetting} />}
            {navActove === SettingChat.appearance && <Appearance self={DataSetting} />}
            {navActove === SettingChat.message && <Message self={DataSetting} />}
            {navActove === SettingChat.notification && <Notification self={DataSetting} />}
            {navActove === SettingChat.chat && <Chat self={DataSetting} />}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ModalSetting;
